var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCourseMathematics = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 98,
    viewBox: "0 0 104 98",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 98,
    rx: 10,
    fill: "url(#paint0_linear_3333_313363)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8534 27H67.1575C71.4844 27 75 30.5156 75 34.8534V64.1575C74.9892 68.4844 71.4844 72 67.1466 72H37.8425C33.5156 71.9892 30 68.4844 30 64.1466V34.8425C30.0108 30.5156 33.5156 27 37.8534 27ZM67.1575 69.8365C70.2945 69.8365 72.8365 67.2945 72.8365 64.1575V34.8425C72.8257 31.7055 70.2837 29.1635 67.1466 29.1635H37.8425C34.7055 29.1743 32.1635 31.7163 32.1635 34.8534V64.1575C32.1743 67.2945 34.7163 69.8365 37.8534 69.8365H67.1575Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5601 56.9922H43.4304V53.5662C43.4304 52.9642 42.9268 52.4717 42.3113 52.4717C41.6958 52.4717 41.1921 52.9642 41.1921 53.5662V56.9922H37.0625C36.447 56.9922 35.9434 57.4847 35.9434 58.0867C35.9434 58.6887 36.447 59.1813 37.0625 59.1813H41.1921V63.2639C41.1921 63.8659 41.6958 64.3585 42.3113 64.3585C42.9268 64.3585 43.4304 63.8659 43.4304 63.2639V59.1813H47.5601C48.1756 59.1813 48.6792 58.6887 48.6792 58.0867C48.6792 57.4847 48.1756 56.9922 47.5601 56.9922Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5601 38.8867H37.0625C36.447 38.8867 35.9434 39.2688 35.9434 39.7358C35.9434 40.2028 36.447 40.5848 37.0625 40.5848H47.5601C48.1756 40.5848 48.6792 40.2028 48.6792 39.7358C48.6792 39.2688 48.1756 38.8867 47.5601 38.8867Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0884 60.9619H56.5908C55.9753 60.9619 55.4717 61.344 55.4717 61.811C55.4717 62.278 55.9753 62.66 56.5908 62.66H67.0884C67.7039 62.66 68.2075 62.278 68.2075 61.811C68.2075 61.344 67.7039 60.9619 67.0884 60.9619Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0884 55.8682H56.5908C55.9753 55.8682 55.4717 56.2502 55.4717 56.7172C55.4717 57.1842 55.9753 57.5663 56.5908 57.5663H67.0884C67.7039 57.5663 68.2075 57.1842 68.2075 56.7172C68.2075 56.2502 67.7039 55.8682 67.0884 55.8682Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2073 43.0256C66.2073 43.0256 66.2073 43.0256 66.1966 43.0149L63.3417 40.16L66.1966 37.3052C66.6121 36.8897 66.6121 36.2186 66.1966 35.8032C65.7812 35.3877 65.1101 35.3877 64.6946 35.8032L61.8397 38.658L58.9849 35.8032C58.5694 35.3877 57.8983 35.3877 57.4829 35.7925C57.0674 36.208 57.0674 36.8791 57.4722 37.2945C57.4722 37.2945 57.4722 37.2945 57.4829 37.3052L60.3377 40.16L57.4829 43.0149C57.0674 43.4197 57.0674 44.1015 57.4829 44.5169C57.8983 44.9324 58.5694 44.9324 58.9849 44.5169L61.8397 41.6621L64.6946 44.5169C65.1101 44.9324 65.7812 44.9324 66.1966 44.5276C66.6121 44.1121 66.6121 43.441 66.2073 43.0256Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3333_313363",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24C5C9"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCourseMathematics, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CourseMathematics.cc150d84.svg";
export { ForwardRef as ReactComponent };